import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myOrder from './views/my-order'
import myOrderDetails from './views/my-order-details'

export default [
  {
    path: RoutePathConstants.MY_ORDER,
    name: 'myOrder',
    component: myOrder
  },
  {
    path: RoutePathConstants.MY_ORDER_DETAILS,
    name: 'myOrderDetails',
    component: myOrderDetails
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/routers.js